import React from 'react';
import { FilterOption } from '@spark-labs/avocado-ui/dist/utils/filter';
import { BubbleBadge } from './BubbleUI';
import { InlineIcon } from '@spark-labs/avocado-ui/dist/components/InlineIcon';

import './FilterList.scss';

/**
 * The FilterList combines a group of `AppliedFilters` and shows the ones that are selected.
 * When one of those filters is deleted, the `onFilterDelete` is called with the index of the
 * `AppliedFilters` object and the filter that was deleted.
 *
 */
export interface FilterListProps {
  filters: Array<{ name: string; filters: FilterOption[]; color?: string }>;
  onFilterDelete?: (name: string, filter: FilterOption) => void;
  onAllFilterDelete?: () => void;
}

export function FilterList(props: FilterListProps) {
  const { filters: allFilters, onFilterDelete, onAllFilterDelete } = props;

  let filterElements: React.ReactNode[] = [];

  allFilters.forEach(({ name, filters, color }) => {
    filters
      .filter(f => f.selected && f.type !== 'all')
      .forEach(f => {
        let filterPrefix = f.type === 'category' ? `${name.toLowerCase()}:` : '';

        filterElements.push(
          <BubbleBadge
            key={f.id}
            clickable
            color={color}
            inverse
            className="filterlist-badge border-0-i"
            onClick={() => onFilterDelete && onFilterDelete(name, { ...f, selected: false })}
          >
            <div className="flex items-center">
              <InlineIcon name="close" className="text-xxs-i p-0-i mr-1" />
              <span>{`${filterPrefix}${f.label}`}</span>
            </div>
          </BubbleBadge>
        );
      });
  });

  let filterCount = filterElements.length;

  return (
    <div className="FilterList flex flex-wrap leading-normal">
      {filterCount > 0 && (
        <>
          <BubbleBadge
            inverse
            clickable
            variant="crimson"
            className="filterlist-badge border-0-i"
            onClick={() => onAllFilterDelete && onAllFilterDelete()}
          >
            <div className="flex items-center">
              <InlineIcon name="close" className="text-xxs-i p-0-i mr-1" />
              <span>Clear all filters</span>
            </div>
          </BubbleBadge>
          {filterElements}
        </>
      )}
    </div>
  );
}
